<template>
  <ConfirmationModal
    cancelTestID="orgSwitchPromptDialog-button-cancel"
    confirmTestID="orgSwitchPromptDialog-button-confirm"
    modalTestID="orgSwitchPromptDialog-dialog"
    :confirmText="$t('organization_settings.switch_organization.confirm')"
    :isLoading="isSwitching"
    :show="isDialogVisible"
    :text="confirmationMessage"
    :title="$t('organization_settings.switch_organization.prompt_title')"
    @cancel="handleCancel"
    @confirm="handleConfirm"
  />
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import mixin from '@/mixins/mixin.vue'
import ConfirmationModal from '@/components/Modals/ConfirmationModal.vue'

export default {
  name: 'OrgSwitchPromptDialog',

  components: { ConfirmationModal },

  mixins: [mixin],

  data() {
    return { isSwitching: false }
  },

  computed: {
    ...mapGetters(['pendingOrgSwitch']),

    confirmationMessage() {
      return this.$t(
        'organization_settings.switch_organization.prompt_message',
        {
          organizationName: this.pendingOrgSwitch?.organizationName,
        }
      )
    },

    isDialogVisible() {
      return !_.isNull(this.pendingOrgSwitch)
    },
  },

  methods: {
    ...mapActions(['switchOrganization', 'clearPendingOrgSwitch']),

    handleCancel() {
      this.clearPendingOrgSwitch()
    },

    async handleConfirm() {
      if (this.isSwitching) return
      this.isSwitching = true
      try {
        await this.switchOrganization({
          organizationId: this.pendingOrgSwitch.organizationId,
          shouldJoin: [
            this.$constants.accountStatuses.PENDING,
            this.$constants.accountStatuses.CREATED,
          ].includes(this.pendingOrgSwitch.status),
          organizationName: this.pendingOrgSwitch?.organizationName,
          redirectTo: this.pendingOrgSwitch.redirectTo,
        })
      } catch (error) {
        this.showError(
          this.$t('organization_settings.switch_organization.error')
        )
        this.isSwitching = false
      }
    },
  },
}
</script>
